import { Dispatch, useMemo, useReducer } from 'react';
import { ActionsType, HeadCell, StateType } from '../components/EnhancedTable/EnhancedTable.types';
import { useSearchParams } from 'react-router-dom';

type useSortingReturnType<ColumnsIds> = [StateType<ColumnsIds>, Dispatch<ActionsType<ColumnsIds>>];

export function useSorting<ColumnsIds>(
  columns: readonly HeadCell<ColumnsIds>[],
  defaultLimit?: number
): useSortingReturnType<ColumnsIds> {
  const [searchParams] = useSearchParams();

  const initialState: StateType<ColumnsIds> = useMemo(() => {
    const orderBy = columns.find((c) => c.id === searchParams.get('field'))?.id ?? columns[1].id;
    const order = searchParams.get('direction') ?? 'asc' === 'asc' ? 'asc' : 'desc';
    const rowsPerPage = Number(searchParams.get('limit')) || (defaultLimit ?? 20);
    const auditOfInterest = Boolean(searchParams.get('auditOfInterest')) || false;
    // validation of search param

    return { orderBy, order, rowsPerPage, auditOfInterest };
  }, [columns, defaultLimit, searchParams]);

  function reducer(state: StateType<ColumnsIds>, action: ActionsType<ColumnsIds>) {
    const { type, payload } = action;
    switch (type) {
      case 'sort':
        return { ...state, order: payload.order, orderBy: payload.orderBy };
      case 'rowsPerPage':
        return { ...state, rowsPerPage: payload };
      case 'auditOfInterest':
        return { ...state, auditOfInterest: payload };
      default:
        throw new Error('Wrong action in sorting table reducer');
    }
  }
  const [state, dispatch] = useReducer(reducer, initialState);
  return [state, dispatch];
}
